module.exports = __webpack_public_path__ + "img/check-circle.09c79142.svg";